<template>
  <ul class="link-list">
      <li>
          <div class="title">
              <div class="text two-line">
                免疫を高める秘訣が<br class="hidePc">簡単にわかる<br>動画で見る「市民公開講座」
              </div>
          </div>
          <a class="thumb" href="./open_lecture">
              <img src="@/assets/common_link/thmb02.jpg" class="hideSp">
              <img src="@/assets/common_link/thmb02_sp.jpg" class="hidePc">
              <btnRounded href to="./open_lecture" class="square font-large">免疫について学ぼう！</btnRounded>
          </a>
      </li>
      <li>
          <div class="title">
              <div class="text one-line">
                学んだ知識を生かして<br class="hidePc">レッツチャレンジ！
              </div>
          </div>
          <a class="thumb" href="https://www.nutas.jp/84shindan/" target="_blank">
              <img src="@/assets/common_link/thmb01.jpg" class="hideSp">
              <img src="@/assets/common_link/thmb01_sp.jpg" class="hidePc">
              <btnRounded href to="https://www.nutas.jp/84shindan/" target="_blank" class="square font-large">栄養力診断を受ける</btnRounded>
          </a>
      </li>
  </ul>
</template>

<script>
import btnRounded from '@/components/parts/btn-rounded.vue'

export default {
    name: 'btn-bar',
    props:{
        pagename: String,
    },
    components:{
        btnRounded
    }
}
</script>

<style lang="scss" scoped>
.link-list {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 200px;
    @media #{$maxM}{
        padding-bottom: 220px;
    }
  li {
    margin-bottom: 7.5em;
    &:nth-last-child(1){
        margin-bottom: 0;
    }
    @media #{$maxM}{
      margin-bottom: 6em;
    }
  }
  .title {
    .text {
      font-size: 1.625em;
      line-height: 1.8;
      letter-spacing: 0.2em;
      margin-bottom: 0.4em;
      display: inline-block;
      position: relative;
      @media #{$maxM}{
        font-size: 1.285715em;
      }
      &:before {
        content: '';
        display: inline-block;
        width: 1px;
        background: black;
        position: absolute;
        top: 0.2em;
        left: -1em;
      }
      &:after {
        content: '';
        display: inline-block;
        width: 1px;
        background: black;
        position: absolute;
        top: 0.2em;
        right: -1em;
      }
      @media #{$maxM}{
        &:before {
          top: 0.45em;
        }
        &:after {
          top: 0.45em;
        }
      }
      &.two-line:before {
        height: 3em;
        transform: rotate(-15deg);
      }
      &.two-line:after {
        height: 3em;
        transform: rotate(15deg);
      }
      &.one-line:before {
        height: 1.5em;
        transform: rotate(-30deg);
      }
      &.one-line:after {
        height: 1.5em;
        transform: rotate(30deg);
      }
      @media #{$maxM}{
        &.two-line:before {
          height: 4.5em;
          transform: rotate(-10deg);
        }
        &.two-line:after {
          height: 4.5em;
          transform: rotate(10deg);
        }
        &.one-line:before {
          height: 3em;
          transform: rotate(-15deg);
        }
        &.one-line:after {
          height: 3em;
          transform: rotate(15deg);
        }
      }
    }
  }
  .thumb {
    display: block;
    border: 1px solid black;
    position: relative;
    transition: 0.3s;
    @media #{$minM}{
      &:hover {
        opacity: 0.6;
      }
    }
    .square {
      position: absolute;
      bottom: 0;
      right: 0;
      color: white;
      border-radius: 0;
      background: black;
      height: 50px;
      @media #{$maxM}{
        height: 34px;
        box-sizing: border-box;
        width: 100% !important;
        max-width: none !important;
      }
      /deep/ .btn-inner {
        padding: 0 50px 0 40px;
        span {
          font-size: 1.125em;
        }
      }
      /deep/ .icon {
        right: 20px;
      }
    }
  }
}
</style>